import { render, staticRenderFns } from "./PersonaCharts.vue?vue&type=template&id=54771900&scoped=true&"
import script from "./PersonaCharts.vue?vue&type=script&lang=js&"
export * from "./PersonaCharts.vue?vue&type=script&lang=js&"
import style0 from "./PersonaCharts.vue?vue&type=style&index=0&id=54771900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54771900",
  null
  
)

export default component.exports